module.exports = __webpack_public_path__ + "img/Hypoxia-OVCA_10X_TIP.4bb54b2c.png";